import { createContext, useReducer } from "react"
import { Action, Template, TemplateState, defaultTemplate, defaultTemplateState, reducer } from "./templateModel"
import { useTemplate } from "./templateQueries"
import CatalogItemHandler from "./CatalogItemHandler"

type TemplateContextData = {
    state: TemplateState
    dispatch: (action: Action) => void
    serverTemplate: Template
    isLoading: boolean
    isTemplateDeleted: boolean
}
  
const TemplateContext = createContext<TemplateContextData>({
    state: defaultTemplateState(),
    dispatch: () => {},
    serverTemplate: defaultTemplate(),
    isLoading: false,
    isTemplateDeleted: false
})
  
export default TemplateContext

export type Props =  React.PropsWithChildren & {
  templateId: number
  isTemplateDeleted: boolean
}

export const TemplateContextWrapper = ({templateId, isTemplateDeleted, children}: Props) => {
    const [state, dispatch] = useReducer(reducer, defaultTemplateState())
    const templateQuery = useTemplate(templateId, isTemplateDeleted)
    const serverTemplate = templateQuery.data ?? {...defaultTemplate(), id: templateId}

    return <TemplateContext.Provider value={{state, dispatch, serverTemplate, isLoading: templateQuery.isLoading, isTemplateDeleted}}>
      <CatalogItemHandler />
      {children}
    </TemplateContext.Provider>
}